
import React, {useMemo} from "react";
import {Context} from "@hotwired/stimulus";
import {useForm} from "react-hook-form";
import {valibotResolver} from "@hookform/resolvers/valibot";
import {ReactWrapperController} from "@root/server/client/esweb/src/lib/stimulus/ReactWrapperController.ts";
import {RhfInput} from "@root/server/client/esweb/components/ui/rhf/RhfInput.tsx";
import {FormServerErrors} from "@root/server/client/esweb/src/pages/web/shared/form-server-errors.tsx";
import {useFormSubmission} from "@root/server/client/esweb/src/lib/hooks/useFormSubmission.ts";
import { Turnstile } from '@marsidev/react-turnstile'

import {
    EmailLinkLoginFormProps,
    EmailLinkLoginFormValues,
    EmailLinkLoginSchema, flow_email_form_name
} from "./flow_email.shared.tsx";

import { t } from "@root/server/client/esweb/src/lib/i18n.ts";
import {ContinueSubmitButton} from "@root/server/client/esweb/src/pages/web/shared/continue-submit-button.tsx";


export const name = flow_email_form_name;

export default class extends ReactWrapperController {
    constructor(context: Context) {
        super(context, (props) => <FlowEmailForm {...props} />);
    }
}


function FlowEmailForm({submitUrl, initialEmail}: EmailLinkLoginFormProps) {
    const defaultValues = useMemo<EmailLinkLoginFormValues>(() => ({
        email: initialEmail ?? "",
    }), [initialEmail]);

    const {control, handleSubmit} = useForm<EmailLinkLoginFormValues>({
        resolver: valibotResolver(EmailLinkLoginSchema),
        defaultValues,
        mode: "onTouched",
        reValidateMode: "onChange",
    });

    const {execute, isSubmitting, canSubmit, serverErrors, turnstileProps} = useFormSubmission<EmailLinkLoginFormValues>({submitUrl, requireTurnstile: true});

    return (
        <form className="space-y-6" onSubmit={handleSubmit(execute)}>
            <div className="space-y-4">
                <RhfInput
                    control={control}
                    name="email"
                    label={t({cs: "E-mail", en: "E-mail"})}
                    inputProps={{
                        type: "email",
                        placeholder: t({cs: "např. jan.novak@email.cz", en: "e.g. john.doe@email.com"}),
                        autoComplete: "email",
                        autoFocus: true,
                    }}
                />
            </div>


            <div className="text-slate-500 text-sm">
                Pokračováním souhlasíte s <a href="/web/static/terms" className="underline">Podmínkami použivání a zásadami ochrany osobních údajů</a>
            </div>
            <Turnstile {...turnstileProps} />

            <FormServerErrors errors={serverErrors} />

            <ContinueSubmitButton {...{isSubmitting, canSubmit}}/>
        </form>
    );
}
